export default "__VITE_ASSET__DV$Vthlx__"